import Invoices from "./Invoices";
export default function DeliveryChallans() {
    return <Invoices docType="delivery_challan" title="Delivery Challans" kicker="SALES" subtitle="Goods dispatched without immediate invoicing." newPath="/sales/invoices/new" />;
}
